import React, { useEffect, useState } from "react";
// import 'antd/dist/antd.css';
import "./dashboard.css";
import { Layout, Button, Row, Col, Tooltip } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar/Sidebar";
import ManagerDashboard from "../ManagerDashboard/ManagerDashboard";
import liracypt from "../Liracrypt/liracrypt";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createRoute } from "../../utils/CustomFunc";

const { Header, Sider, Content } = Layout;

function Dashboard(props) {
  let breadCrumbs = [
    {
      "_id": 1,
      "title": "Dashboard",
      "route": "/dashboard",
      "props": ["_id"],
      "params": {
        "a": "b"
      },
      "style": {
        "backgroundColor": "#19E6FF",
        "fontSize": 20,
        "color": "#ffffff"
      },
      "visible": true,
      "enable": true
    },
    {
      "_id": 2,
      "title": "Phantom Prime",
      "style": {
        "backgroundColor": "#19E6FF",
        "fontSize": 20,
        "color": "#ffffff"
      },
      "route": "/pp",
      "visible": true,
      "enable": true,
      "props": ["_id"],
      "params": {
        "dictName": "PmToolQuery"
      },
    },
  ]
  const [collapsed, setCollapsed] = useState(false);
  const urlCode = useSelector(state => state.urlCode);
  const pageHeader = useSelector(state => state.dashboardPageName)
  const [loading, setLoading] = useState(false);
  const isMenuCollapsed = useSelector(state => state.isMenuCollapsed);
  const history = useHistory();
  const dispatch = useDispatch();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const navigateToLink = (x) => {
    let link = createRoute({
      route: x.route,
      multiProps: x.props,
      params: x.params,
      record: x,
      urlCode: localStorage.getItem('urlCode')
    });
    history.push(link);
  }

  useEffect(() => {
    liracypt.get('/loginstate', {})
      .then(res => {
        console.log(res);
      }).catch(err => {
        console.log(err);
      })
  }, []);

  // const username = useSelector((state) => state.user);

  // console.log(username);

  const logout = (setLoading) => {
    setLoading(true);
    setTimeout(() => {
      liracypt.logout(history, dispatch, setLoading, `/v02/${urlCode}/login`);
    }, 100);
  };

  const navigateToHome = () => {
    const homePageLink = localStorage.getItem('homePage') || `/v02/${urlCode}/dashboard`;
    history.push(homePageLink);
  }

  return (
    <Layout className="layout-container" style={{ backgroundColor: "#3b3b3b", flexDirection: 'row' }}>
      {/* <Sider trigger={null} collapsible collapsed={this.state.collapsed}>
                    <div className="logo" /> */}

      <>
        {props.onlyBackground ? null : window.innerWidth > 700 ? (
          <Sidebar collapsed={true} />
        ) : (
          <></>
        )}
      </>


      <Layout className={`site-layout ${isMenuCollapsed ? 'menu-closed' : 'menu-opened'}`} style={{ backgroundColor: localStorage.getItem('bgColor') || '#000000' }}>
        {/* <Header
          className="site-layout-background"
          style={{
            padding: 0,
            display: "flex",

            alignItems: "center",
          }}
        >
          <Row>
            <Col span={8}>
              <Tooltip
                title={"liradolf.png"}
                placement="right"
              >
                <img
                  className="spin"
                  src={"http://liradolf.com/wp-content/uploads/2015/01/Logo/liradolf.png"}
                  width="100%"
                  style={{ maxHeight: "50px" }}
                  alt="logo"
                ></img>
              </Tooltip>
            </Col>
            <Col span={8}>
              <h5
                style={{
                  margin: 0,
                  color: "#fff",
                  textShadow: "2px 2px #07244c",
                  fontWeight: 600,
                  fontSize: "1.2rem",
                }}
              >
                {pageHeader}
              </h5>
            </Col>
            <Col span={8}>
              <div style={{ display: "flex", marginRight: "20px" }}>
                <span
                  style={{ fontSize: "13px", color: "#fdebd3", fontWeight: "300" }}
                >
                  Welcome {localStorage.getItem("uname")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  flex: 1,
                }}
              >
                <div>
                  <Button
                    id="logoutButton"
                    loading={loading}
                    style={{
                      backgroundColor: "#007bff",
                      fontWeight: 600,
                      color: "#fff",
                      border: 0,
                      borderRadius: "20px",
                      marginRight: "20px",
                    }}
                    onClick={() => logout(setLoading)}
                  >
                    Logout
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Header> */}
        <Row justify="space-between" align="middle" className="linedashzen-header" style={{ padding: 6 }}>
          {
            localStorage.getItem('corpLogo') ?
              <Col span={4}>
                <div onClick={navigateToHome} style={{ cursor: 'pointer', padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginLeft: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%' }}>
                  <Tooltip
                    title={"logo"}
                    placement="right"
                  >
                    <img
                      className="spin"
                      src={localStorage.getItem('corpLogo')}
                      width="100%"
                      style={{ maxHeight: "50px", width: 'auto' }}
                      alt="logo"
                    ></img>
                  </Tooltip>
                </div>
              </Col> : <></>
          }

          <Col
            span={localStorage.getItem('corpLogo') ? 14 : 18}
            style={{ padding: "10px 10px 10px 10px", textAlign: "center" }}
          >
            <h5
              style={{
                margin: 0,
                color: "#fff",
                textShadow: "2px 2px #07244c",
                fontWeight: 600,
                fontSize: "1.2rem",
              }}
            >
              {pageHeader}
            </h5>
          </Col>
          {
            localStorage.getItem('corpLogo2') ?
              <Col span={4}>
                <div onClick={navigateToHome} style={{ cursor: 'pointer', padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginLeft: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%' }}>
                  <Tooltip
                    title={"logo"}
                    placement="right"
                  >
                    <img
                      className="spin"
                      src={localStorage.getItem('corpLogo2')}
                      width="100%"
                      style={{ maxHeight: "50px", width: 'auto' }}
                      alt="logo"
                    ></img>
                  </Tooltip>
                </div>
              </Col> : <Col span={6}>
                <div style={{ padding: "10px 10px", borderRadius: 7, marginRight: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span
                    style={{ fontSize: "13px", color: "#fdebd3", fontWeight: "300" }}
                  >
                    Welcome {localStorage.getItem("uname")}
                  </span>
                  <Button
                    id="logoutButton"
                    loading={loading}
                    style={{
                      backgroundColor: "#007bff",
                      fontWeight: 600,
                      color: "#fff",
                      border: 0,
                      borderRadius: "20px",
                      marginRight: "20px",
                    }}
                    onClick={() => logout(setLoading)}
                  >
                    Logout
                  </Button>
                </div>

              </Col>
          }
          {/* <Col span={6}>
            <div style={{ padding: "10px 10px", borderRadius: 7, marginRight: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span
                style={{ fontSize: "13px", color: "#fdebd3", fontWeight: "300" }}
              >
                Welcome {localStorage.getItem("uname")}
              </span>
              <Button
                id="logoutButton"
                loading={loading}
                style={{
                  backgroundColor: "#007bff",
                  fontWeight: 600,
                  color: "#fff",
                  border: 0,
                  borderRadius: "20px",
                  marginRight: "20px",
                }}
                onClick={() => logout(setLoading)}
              >
                Logout
              </Button>
            </div>

          </Col> */}
        </Row>

        {/* <div style={{ display: 'inline-flex', flexWrap: 'wrap', marginTop: 10, marginLeft: 10 }}>
          {
            breadCrumbs.map((x, i) => (
              <div onClick={() => navigateToLink(x)} class="pointer" style={{ ...x.style, '--liraBg': localStorage.getItem('bgColor'), '--breadCrumBG': x.style?.backgroundColor, }}>
                <span>{x.title}</span>
              </div>

            ))
          }
        </div> */}
        {/* <ManagerDashboard /> */}
        {props.children}

      </Layout>
    </Layout >
  );
}

export default Dashboard;

